import Link from 'next/link';
import { useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { IVideo } from '@features/productPreview/typescript';
import { WindowType } from '@typescript/index';
import useIntersect from '@hooks/useIntersect';
import ProductPreviewPageState from '@features/productPreview/mobX/state/ProductPreviewPageState';
import styles from '@features/productPreview/sections/AboutCollection/AboutCollectionVideoPlayer.styles';
import Button from '@components/Button/Button';
import VideoPlayer from '@components/Video/VideoPlayer';
type PropsType = {
  videos: IVideo[];
  collectionName: string;
  link: string;
  buttonText: string;
  currentView: WindowType;
  state: ProductPreviewPageState;
};
const AboutCollectionVideoPlayer = ({
  videos,
  link,
  buttonText,
  currentView,
  state
}: PropsType) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const entry = useIntersect(ref, {
    rootMargin: '0px',
    threshold: 0.5,
    onlyOnce: true
  });
  useEffect(() => {
    state.setEntry(entry);
  }, [entry]);
  if (videos.length === 0) return null;
  const handleEndVideo = () => {
    state.setNextActiveVideo();
  };
  const handleStartVideo = (videoId: number) => {
    state.setActiveVideo(videoId);
  };
  const desktop = currentView === WindowType.desktop;
  return <div sx={styles.collectionContainer}>
      {videos.map((video: IVideo, index: number) => {
      const active = state.activeVideo === index;
      const addMargin = index === videos.length - 1;
      return <div sx={styles.videoItemContainer(index)} key={video.id}>
            <div sx={styles.sliderVideo(index)} onMouseEnter={() => {
          state.setActiveVideo(index);
        }} onClick={() => {
          state.setActiveVideo(index);
        }} onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            state.setActiveVideo(index);
          }
        }} role="button" tabIndex={0} ref={index === 0 ? ref : null} data-cy="AboutCollectionVideoSection">
              <VideoPlayer video={video.video} playVideo={active} withSound={false} controls={active} loop={false} isEndFunc={() => handleEndVideo()} onLoaded={() => handleStartVideo(index)} />
            </div>
            <div sx={styles.descriptionContainer}>
              <p sx={styles.description(desktop && addMargin)}>{video.description}</p>
              {desktop && index === videos.length - 1 && <Link href={link}>
                  <Button variant="outlined">{buttonText}</Button>
                </Link>}
            </div>
          </div>;
    })}
      {!desktop && <Link href={link} sx={styles.link}>
          <Button variant="outlined">{buttonText}</Button>
        </Link>}
    </div>;
};
export default observer(AboutCollectionVideoPlayer);